// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__saaM7","shadowContainer":"styles_shadowContainer__OeL_x","shadow":"styles_shadow__wzhCh","title":"styles_title__rhjzg","desc":"styles_desc__HRwJN"};